import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
	MotifTabNavigation,
	MotifTabControl,
	MotifIcon,
} from "@ey-xd/motif-react";
import { PaymentStatusTab } from "./PaymentStatusType";
import { setCurrentTab } from "./PaymentStatusSlice";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import BankTransactions from "./bankTransactions/BankTransactions";
import Payments from "./payments/Payments";
import "./PaymentStatus.scss";

const PaymentStatus = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const selectedTab = useSelector(
		(state: any) => state.paymentStatus.currentTab
	);

	const renderTabContent = () => {
		switch (selectedTab) {
			case PaymentStatusTab.Payments:
				return <Payments />;
			case PaymentStatusTab.BankTransactions:
				return <BankTransactions />;
			default:
				return <></>;
		}
	};

	return (
		<>
			{window.location.pathname.includes("/payments") && (
				<Breadcrumb
					items={[
						{
							text: t("pages.configuration.attributes.backButton"),
							url: "/",
							icon: <MotifIcon src={IconoirArrowLeft} />,
						},
					]}
				/>
			)}
			<div className="paymentStatus-container">
				<MotifTabNavigation
					defaultActiveKey={selectedTab}
					orientation="vertical"
					controlled={true}
				>
					<MotifTabControl
						className={
							selectedTab === PaymentStatusTab.Payments ? "motif-active" : ""
						}
						key={PaymentStatusTab.Payments}
						onClick={() => dispatch(setCurrentTab(PaymentStatusTab.Payments))}
					>
						{t("pages.paymentStatus.paymentStatusTab.payments")}
					</MotifTabControl>

					<MotifTabControl
						className={
							selectedTab === PaymentStatusTab.BankTransactions
								? "motif-active"
								: ""
						}
						key={PaymentStatusTab.BankTransactions}
						onClick={() =>
							dispatch(setCurrentTab(PaymentStatusTab.BankTransactions))
						}
					>
						{t("pages.paymentStatus.paymentStatusTab.bankTransactions")}
					</MotifTabControl>
				</MotifTabNavigation>

				<div className="paymentStatus-tab-content">{renderTabContent()}</div>
			</div>
		</>
	);
};
export default PaymentStatus;
